import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ObjectIdentifierData} from "../../../../core/shared/basic/object-identifier-data";
import {WidgetData} from "../../../../core/shared/widget/widget-data";
import {Sorting} from "../../../../core/shared/misc/sorting";
import {WidgetFactory} from "../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../core/shared/widget/widget-data-param";
import {FilterCriteria} from "../../../../core/shared/filter/api/filter.criteria";
import {QlJoinDto} from "../../../../core/shared/ql/data/dto/ql-join.dto";
import {ObjectIdentifier} from "../../../../core/shared/basic/object-identifier";

@Component({
    selector: 'ci-search-flexible-insurance',
    templateUrl: './ci-search-flexible-insurance.component.html',
    standalone: false
})
export class CiSearchFlexibleInsuranceComponent
    implements OnInit {

    @Output() onObjectSelect: EventEmitter<ObjectIdentifierData> = new EventEmitter<ObjectIdentifierData>();
    @Input() currentObjectId: number;
    widgetTableViaCustomer: WidgetData;
    activeTab: string = 'searchByCustomer';
    constructor() {

    }

    ngOnInit() {
        if (this.currentObjectId) {

            const obj = {id: this.currentObjectId, name: ''};
            this.handleCustomerObject(obj);

        }
    }

    handleCustomerObjectSelect(o: ObjectIdentifierData | ObjectIdentifier) {
        const event = o as ObjectIdentifierData;
        if (!event.data.contractDto) {
            return;
        }
        const contract = event.data.contractDto;
        const objectIdentifierData: ObjectIdentifierData = new ObjectIdentifierData('cm.Contract', contract.id, contract);
        this.handleObjectSelect(objectIdentifierData);
    }

    handleObjectSelect(event: ObjectIdentifierData | ObjectIdentifier) {
        this.onObjectSelect.emit(event as ObjectIdentifierData);
    }

    /**
     * method to load Contracts info using customer details
     * @param qlJoinDtos
     * @param filterCriteria
     * @private
     */
    private loadTableViaCustomer(qlJoinDtos: QlJoinDto[], filterCriteria: FilterCriteria[]) {
        this.widgetTableViaCustomer = this.loadTable('cr.CustomerInsurableObject', qlJoinDtos, filterCriteria);
    }

    /**
     * method to return the widget table instance
     * @param dataProviderObject
     * @param qlJoinDto
     * @param filterCriteria
     * @private
     */
    private loadTable(dataProviderObject: string, qlJoinDto:  QlJoinDto[], filterCriteria: FilterCriteria[]): WidgetData {
        // const dataProviderListRequest = ObjectRequestList.createWithPaging(
        //     true,
        //     filterCriteria,
        //     [new Sorting('createdDate', false)],
        //     PagingDto.create(0, 8)
        // );
        // dataProviderListRequest.objectRequestComplex = complexSelection;

        // return WidgetFactory.createWidgetTableEntity(
        //     `cm.search.flexible.contracts.${dataProviderObject}`,
        //     'Insurable Objects',
        //     dataProviderObject,
        //     'No Insurable Objects found',
        //     dataProviderListRequest,
        //     WidgetDataParam.create('selectionMode', 'rowSelect'),
        //     WidgetDataParam.create('rowSelectionMode', 'sticky'),
        //     WidgetDataParam.create('size', 'S')
        // );

        return  WidgetFactory.createWidgetQl(
            `cm.search.flexible.contracts.${dataProviderObject}`,
            'Insurable Objects',
            dataProviderObject,
            'table',
            filterCriteria,
            [new Sorting('e.createdDate', false)],
            qlJoinDto,
            WidgetDataParam.create('selectionMode', 'rowSelect'),
            WidgetDataParam.create('rowSelectionMode', 'sticky'),
            WidgetDataParam.create('size', 'S')
        );
    }

    /**
     * handle object when row is selected from customer table
     * @param event
     */
    handleCustomerObject(event: { id: number, name: string }) {
        const filterCriteria: FilterCriteria[] = [];

        filterCriteria.push(
            FilterCriteria.create('e.customerId', FilterCriteria.cOperatorEqual, event.id, null)
        );

        // const complexSelection = ObjectRequestComplex.build(true, false,
        //
        //     ObjectRequestComplexNode.createSimpleAttributeNode('insurableObject')
        // );

        const qlJoinDto: QlJoinDto[] = [
            {
                joinType: "left",
                type: "entity",
                name: "insurableObject",
                as: "cmc"
            }
        ]


        this.loadTableViaCustomer(qlJoinDto, filterCriteria);
    }


}
